//dwain added after install livewire statamic
//import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

//import '@fontsource-variable/inter';
import Cookies from 'js-cookie'

// import { Clip } from '@maveio/components'; WEG GEHAALD OP DISCORD ADVIES
//window.customElements.define('mave-player', Player);

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
//import morph from "@alpinejs/morph";
import persist from "@alpinejs/persist";
import precognition from "laravel-precognition-alpine";
import forms from './forms.js'
import { createData as createShopifyData, createStore as createShopifyStore } from './vendor/shopify/alpine';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css'; // Standaard flatpickr styling
import { Dutch } from "flatpickr/dist/l10n/nl.js";

// Configureer Flatpickr met Nederlandse locale
flatpickr.localize(Dutch);

//Javascript
//Global callback for Google Maps API loading
function handleMapsApiLoaded() {
    if (window.alpineShowroomMapInstance && typeof window.alpineShowroomMapInstance.createMap === 'function') {
      // console.log('Google Maps API loaded via callback. Calling createMap.'); // Voor debugging
      window.alpineShowroomMapInstance.createMap();
      // Clean up the global reference if desired
      // delete window.alpineShowroomMapInstance;
    } else {
      // console.warn('handleMapsApiLoaded called, but window.alpineShowroomMapInstance is not available or createMap is not a function.');
    }
  }
  
// Ensure the function is globally accessible, especially if using modules
window.handleMapsApiLoaded = handleMapsApiLoaded;
  
// Call Alpine.
window.Alpine = Alpine;

Alpine.data('forms', forms);

Alpine.plugin([collapse, focus, persist, precognition]);
createShopifyStore(Alpine);
createShopifyData(Alpine);

document.addEventListener('alpine:init', () => {
    Alpine.data('chatPopup', () => ({
        show: false,
        minimized: Cookies.get('chatMinimized') === 'true',
        currentView: 'main',

        init() {
            // Check if the cookie exists
            if (this.minimized) {
                this.show = false;
            } else {
                // If cookie doesn't exist or is false, show the popup after 2 seconds
                setTimeout(() => {
                    this.show = true;
                }, 4000);
            }
        },

        minimize() {
            this.minimized = true;
            this.show = false;
            Cookies.set('chatMinimized', 'true', { expires: 7 }); // Set cookie to expire in 7 days
        },

        maximize() {
            this.minimized = false;
            this.show = true;
            this.currentView = 'main';
            Cookies.set('chatMinimized', 'false', { expires: 7 }); // Update the cookie when maximized
        }
    }));

    Alpine.data('appointmentField', (options) => ({
        fieldName: options.fieldName,
        businessHours: options.businessHours,
        selectedDate: '',
        selectedTime: '',
        availableTimes: [],
        fieldError: '',
        
        initFlatpickr() {
            try {
                const today = new Date();
                
                // Bereken beschikbare dagen op basis van businessHours
                const enabledDays = this.businessHours
                    .filter(day => day.open)
                    .map(day => day.weekday.value.toLowerCase());

                const instance = flatpickr(this.$refs.datePicker, {
                    locale: Dutch,
                    dateFormat: "Y-m-d",
                    minDate: "today",
                    disable: [
                        function(date) {
                            // Maak van zondag 0, maandag 1, etc. naar de dagen in de businessHours
                            const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                            const dayName = dayNames[date.getDay()];
                            return !enabledDays.includes(dayName);
                        }
                    ],
                    onChange: (selectedDates, dateStr) => {
                        this.selectedDate = dateStr;
                        if (dateStr) {
                            this.generateAvailableTimes(dateStr);
                        } else {
                            this.availableTimes = [];
                            this.selectedTime = '';
                        }
                    }
                });
                
                // Bewaar instance voor eventuele cleanup later
                this.flatpickrInstance = instance;
            } catch (error) {
                console.error('Flatpickr initialisatie fout:', error);
                this.fieldError = 'Er is een probleem opgetreden bij het laden van de datumkiezer.';
            }
        },
        
        generateAvailableTimes(dateStr) {
            try {
                const date = new Date(dateStr);
                const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                const dayName = dayNames[date.getDay()];
                
                // Vind de business hours voor deze dag
                const daySettings = this.businessHours.find(day => day.weekday.value.toLowerCase() === dayName);
                
                if (!daySettings || !daySettings.open) {
                    this.availableTimes = [];
                    return;
                }
                
                // Genereer tijdsloten van 30 minuten tussen start en eind tijd
                const startTime = daySettings.start_time;
                const endTime = daySettings.end_time;
                
                const times = [];
                let current = this.parseTime(startTime);
                const end = this.parseTime(endTime);
                
                while (current < end) {
                    times.push(this.formatTime(current));
                    current.setMinutes(current.getMinutes() + 30);
                }
                
                this.availableTimes = times;
                
                // Reset de geselecteerde tijd wanneer de datum verandert
                this.selectedTime = '';
            } catch (error) {
                console.error('Fout bij genereren van beschikbare tijden:', error);
                this.fieldError = 'Er is een probleem opgetreden bij het laden van de beschikbare tijden.';
            }
        },
        
        parseTime(timeStr) {
            const [hours, minutes] = timeStr.split(':').map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);
            return date;
        },
        
        formatTime(date) {
            return date.toTimeString().substr(0, 5);
        }
    }));
});

Alpine.data("GTMEvent", () => ({
    init() {},
    fireGTM(ev) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "custom_click",
            eventCategory: "Click",
            eventAction: ev,
            eventLabel: window.location.href,
        });
    },
}));
Alpine.data("formHandler", () => ({
    success: false,
    submitted: false,
    form: null,
    init() {
        this.form = this.$form(
            "post",
            this.$refs.form.getAttribute("action"),
            JSON.parse(this.$refs.form.getAttribute("x-data")).form,
            {
                headers: {
                    "X-CSRF-Token": {
                        toString: () =>
                            this.$refs.form.querySelector('[name="_token"]')
                                .value,
                    },
                },
            }
        );
    },
    successHook(response) {
        {
            {
                success_hook;
            }
        }

        setTimeout(() => {
            this.success = false;
        }, 4500);
    },
    submit() {
        this.submitted = true;
        this.form
            .submit()
            .then((response) => {
                this.form.reset();
                this.$refs.form.reset();
                this.success = true;
                this.submitted = false;
                this.successHook(response);
            })
            .then(this.$refs.form.scrollIntoView())
            .catch((error) => {
                const summary = document.querySelector("#summary");
                if (summary) {
                    this.$focus.focus(summary.querySelector("a"));
                } else {
                    console.log(error);
                }
            });
    },
}));
Alpine.data("stepsHandler", () => ({
    step: 1,
    selectedProductSlug: null,
    selectedStorings: [], // Array voor meerdere storingen
    form: {
        product: null,
        storings: null,
        // andere form velden hier
    },

    init() {
        const urlParams = new URLSearchParams(window.location.search);
        const productSlug = urlParams.get("product");
        //const storingSlug = urlParams.get('storing');
        const storingsSlug = urlParams.get("storings")
            ? urlParams.get("storings").split(",")
            : [];

        if (productSlug) {
            this.selectedProductSlug = productSlug;
            setTimeout(() => {
                this.setProductField(productSlug); // Vul het productveld in met de slug
            }, 1000); // 1000 milliseconden vertraging
            this.step = 2;

            if (storingsSlug.length > 0) {
                this.selectedStorings = storingsSlug;
                setTimeout(() => {
                    this.setStoringField(); 
                }, 1000); // 1000 milliseconden vertraging
                this.step = 2;
            }
        }
    },

    selectProduct(slug) {
        this.selectedProductSlug = slug;
        this.setProductField(slug); // Vul het productveld in met de slug
        this.updateUrl();
        this.nextStep();
    },

    //   setProductField(slug) {
    //       const productInput = document.getElementById('product');
    //       if (productInput) {
    //           productInput.value = slug; // Stel de waarde van het input veld in
    //           this.form.product = slug;  // Zorg ervoor dat het form object wordt bijgewerkt
    //       }
    //   },
    setProductField(slug) {
        this.form.product = slug;
        const productInput = document.getElementById("product");
        if (productInput) {
            productInput.value = slug;
            productInput.dispatchEvent(new Event("input")); // Trigger input event
        }
    },

    toggleStoring(slug) {
        const index = this.selectedStorings.indexOf(slug);
        if (index === -1) {
            this.selectedStorings.push(slug); // Voeg toe als het niet bestaat
        } else {
            this.selectedStorings.splice(index, 1); // Verwijder als het al geselecteerd is
        }
        this.setStoringField(); // Update de input met de huidige selectie
        this.updateUrl();
    },

    updateUrl() {
        let url = new URL(window.location.href);
        url.searchParams.set("product", this.selectedProductSlug);

        if (this.selectedStorings.length > 0) {
            url.searchParams.set("storings", this.selectedStorings.join(","));
        } else {
            url.searchParams.delete("storings");
        }

        window.history.pushState({}, "", url);
    },

    setStoringField() {
        const storingInput = document.getElementById("storing"); // Zorg ervoor dat dit het juiste ID is
        if (storingInput) {
            const storingsWithSpacesAndCapitals = this.selectedStorings.map(slug => 
                slug.replace(/-/g, " ") // Vervang alle '-' door spaties
                    .replace(/\b\w/g, char => char.toUpperCase()) // Zet eerste letter van elk woord in hoofdletter
            );
            storingInput.value = storingsWithSpacesAndCapitals.join(", "); // Vul de input met een komma-gescheiden lijst
            storingInput.dispatchEvent(new Event("input")); // Trigger input event
        }
    },

    selectStoring(slug) {
        this.selectedStoringSlug = slug;
        this.setStoringField(slug); // Vul het storing veld in met de slug
        this.updateUrl();
        this.nextStep();
    },

    nextStep() {
        if (this.step === 1) {
            this.step++;
        } else {
            if (this.step === 2 && this.selectedStorings.length > 0) {
                this.step = 3;
            }
        }
    },

    previousStep() {
        if (this.step > 1) {
            this.step--;
            this.updateUrl();
        }
    },

    goToStep(step) {
        if (
            step <= this.step ||
            (step === 3 && this.selectedStorings.length > 0)
        ) {
            this.step = step;
            this.updateUrl();
        }
    },
}));

// if (window.livewireScriptConfig?.csrf === 'STATAMIC_CSRF_TOKEN') {
//   document.addEventListener('statamic:nocache.replaced', () => Livewire.start());
// } else {
//   Livewire.start();
// }

Alpine.start();

// Verwijder de oude header scroll functie
var header = document.getElementById("stickyHeader");
if (header) {
    let lastScrollTop = 0;
    let headerHeight = header.offsetHeight;
    
    // Voeg onze nieuwe verbeterde scroll handler toe met passive listener
    window.addEventListener('scroll', function() {
        handleHeaderScroll();
    }, { passive: true });
    
    window.addEventListener('resize', handleHeaderScroll, { passive: true });

    // Handle scroll behavior for both desktop and mobile
    function handleHeaderScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollingDown = scrollTop > lastScrollTop;
        const informationBar = document.getElementById('information-bar');
        const isMobile = window.innerWidth < 768;
        
        // Desktop behavior (>=768px)
        if (!isMobile) {
            // Op desktop blijven zowel informatiebalk als header vast staan
            if (informationBar) {
                informationBar.classList.add('sticky', 'top-0', 'z-50');
                
                if (scrollTop > 10) {
                    informationBar.classList.add('scrolled');
                    header.classList.add('scrolled');
                } else {
                    informationBar.classList.remove('scrolled');
                    header.classList.remove('scrolled');
                }
            }
            
            if (header) {
                const infoBarHeight = informationBar ? informationBar.offsetHeight : 0;
                header.classList.add('sticky');
                header.style.top = infoBarHeight + 'px';
                header.style.zIndex = '60';
            }
        } 
        // Mobile behavior (<768px)
        else {
            if (informationBar) {
                if (scrollTop > 0) {
                    informationBar.classList.add('fixed', 'top-0', 'w-full', 'z-[991]');
                    header.style.top = informationBar.offsetHeight + 'px';
                    
                    // Header verbergen bij naar beneden scrollen
                    if (scrollingDown && scrollTop > headerHeight) {
                        header.classList.add('-translate-y-full');
                        header.classList.add('fixed_top');
                    } 
                    // Header tonen bij klein beetje omhoog scrollen
                    else if (!scrollingDown) {
                        header.classList.remove('-translate-y-full');
                        header.classList.add('fixed_top');
                    }
                } else {
                    // Reset wanneer boven aan de pagina
                    informationBar.classList.remove('fixed', 'top-0', 'w-full', 'z-[991]');
                    header.classList.remove('fixed_top', '-translate-y-full');
                    header.style.top = '';
                }
            }
        }
        
        // Update lastScrollTop voor volgende keer
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
    
    // Run once on page load
    handleHeaderScroll();
}

// Verwijder de contradicterende Alpine.js component
// Alpine.data('stickyHeader', () => ({ ... }));

// Initialization of the sticky header
document.addEventListener('DOMContentLoaded', function() {
    // Initialize Alpine.js
    Alpine.start();
});
